import { ColumnEditorOptions } from "primereact/column";
import { Button } from "primereact/button";

interface BooleanEditorProps {
    options: ColumnEditorOptions;
}

export const BooleanEditor = ({ options }: BooleanEditorProps) => {
    const currentValue = options.value;

    const handleSelect = (value: boolean) => {
        if (options.editorCallback) {
            options.editorCallback(value);
        }
    };

    // Parse the current value - could be boolean, string "true"/"false", or "YES"/"NO"
    const isYes = currentValue === true || currentValue === "true" || currentValue === "YES";
    const isNo = currentValue === false || currentValue === "false" || currentValue === "NO";

    return (
        <div className="flex gap-2">
            <Button
                label="YES"
                size="small"
                severity={isYes ? "success" : "secondary"}
                outlined={!isYes}
                onClick={() => handleSelect(true)}
            />
            <Button
                label="NO"
                size="small"
                severity={isNo ? "danger" : "secondary"}
                outlined={!isNo}
                onClick={() => handleSelect(false)}
            />
        </div>
    );
};

export const booleanDisplayTemplate = (value: unknown): string => {
    if (value === true || value === "true" || value === "YES") {
        return "YES";
    }
    if (value === false || value === "false" || value === "NO") {
        return "NO";
    }
    return String(value ?? "");
};
